import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { Router } from '@angular/router';
import { getUrlEnvironment } from '../shared/environment';

export interface UserDetails {
    id: string;
    streetAddr1: string;
    email: string;
    phone: string;
    Pagina_Web: string;
    R8184516: string;
}

interface TokenResponse {
    sessionId: string;
    status: number;
}

interface TokenResponseid {
    id: string;
}

export interface TokenPayload {
    email: string;
    password: string;
    name?: string;
}

@Injectable()
export class AuthenticationService {
    private id: string;
    private token: string;

    constructor(private http: HttpClient, private router: Router) { }

    private saveToken(token: string): void {
        this.setLocalItem('mean-token', token, this.getTimeExpire());
        this.token = token;
    }

    public getToken(): string {
        let LocalItem = this.getLocalItem('mean-token');
        return LocalItem;
    }

    private saveId(id: string): void {
        this.setLocalItem('mean-id', id, this.getTimeExpire());
        this.id = id;
    }

    private saveContactoId(id: string): void {
        this.setLocalItem('contactoId', id, this.getTimeExpire());
    }

    setLocalItem(key, id, time?) {
        time = time || 0;
        let timestamp = this.setTimeToLive(time);
        let storageObj = {
            'timestamp': timestamp,
            'value': id
        };
        sessionStorage.setItem(key, JSON.stringify(storageObj));
    }

     //funcion get
     getLocalItem(key) {        
        let storage = sessionStorage.getItem(key);
        let item = null;

        if(storage){
            item = JSON.parse(storage); 
        }

        if (item) { 
            let time = this.evaluateTimeToLive(item.timestamp);
            if (time) {
                return item.value;
            } else {
                sessionStorage.removeItem(key);
                return false;
            }
        } 
        else {
            return false;
        }
    }

    setTimeToLive(lifespan) {
        let currentTime = new Date().getTime();
        let timeToLive;
        if (lifespan !== 0) {
            timeToLive = currentTime + lifespan;
        } else {
            timeToLive = 0; 
        }
        return timeToLive;
    }

    // obtiene la fecha actual y suma el tiempo limite de sesión
    getTimeExpire(){
        var min = 60 * 1000;
        var after = 30 * min;
        return after;
    }

    //Evalua el tiempo determina para la sesión
    evaluateTimeToLive(timestamp) {
        let currentTime = new Date().getTime();
        if (currentTime <= timestamp || timestamp === 0) {
        return true;
        } else {
        return false;
        }
    }

    // tslint:disable-next-line:comment-format
    //remove the item session from the storage
    removeLocalItem(key) {
        return sessionStorage.removeItem(key);
    }

    public getId(): string {
        let id = this.getLocalItem('mean-id');
        return id;
    }

    public getUserDetails(): UserDetails {
        const token = this.getToken();
        let payload;
        if (token) {
            payload = token.split('.')[1];
            payload = window.atob(payload);
            return JSON.parse(payload);
        } else {
            return null;
        }
    }

    public getIdUserLoggedIn(): string {
        return this.getId();
    }

    public isLoggedIn(): boolean {
        const user = this.getToken();
        if (user) {
            return true;
        } else {
            return false;
        }
    }

    private request(method: 'post' | 'get', type: 'login' | 'register' | 'profile', user?: TokenPayload): Observable<any> {
        let base;

        if (method === 'get') {
            //https://www.impeltechnology.com/router/servlet/Router?act=login&loginName=timo&password=qaws12pj
            base = this.http.get(`${getUrlEnvironment()}router/servlet/Router?act=login&loginName=${user.email}&password=${user.password}&output=json`); //, user);
        }

        const request = base.pipe(
            map((data: TokenResponse) => {
                return data;
            })
        );
        return request;
    }

    public getIdUser(username: string, password: string, sessionId: string): Observable<any> {
        //let query = encodeURI("select R8184516,name,Correo_Electronico,Telefono_movil,NombreCiudad,contrasea,id,NombreDepartamento from Contactos where Correo_Electronico='") + username + encodeURI("'") + " and Contrasea='" + password + encodeURI("'") + " ORDER BY name WITH (NOLOCK)";
        let query = encodeURI("select R348354,name,Job_Title,email,mobilePhone,Contrasena,id from contact_monthe where email='") + username + encodeURI("'") + " and Contrasena='" + password + encodeURI("'");
        let url = `${getUrlEnvironment()}rest/api/selectQuery?query=` + query + "&sessionId=" + sessionId + "&output=json&maxRows=1";
        let base = this.http.get(url);
        const request = base.pipe(
            map((data) => {
                if ((data != "") && (data != undefined)) {
                    this.SaveProfile(JSON.stringify(data[0]));
                    this.saveContactoId(data[0][6]);
                    this.saveId(data[0][0]);
                    this.saveToken(sessionId);
                } else {
                    this.saveContactoId('');
                    this.SaveProfile("");
                    this.saveId("");
                    this.saveToken("");
                    return Observable.throw("Error al loguear");
                }
                return data;
            })
        );
        return request;
    }

    public getIdUserByEmail(username: string, sessionId: string): Observable<any> {
        let query = encodeURI("select id,name,Job_Title,email,mobilePhone,Contrasena from contact_monthe");
        // where Correo_Electronico='") + username + encodeURI("'");
        let url = `${getUrlEnvironment()}rest/api/selectQuery?query=` + query + "&sessionId=" + sessionId + "&output=json&maxRows=1";
        let base = this.http.get(url);
        const request = base.pipe(
            map((data) => {
                if ((data != "") && (data != undefined)) {
                   return data;
                } else {
                    return Observable.throw("Error al loguear");
                }
            })
        );
        return request;
    }

    public runActionService(id: string, token: string): Observable<any> {
        try {
            const url = `${getUrlEnvironment()}rest/api/runAction?sessionId=${token}&objName=Contactos&id=${id}&actionId=0V05E-s7SLC6lcY1YzdZUg&output=json`;
            return this.http.post(url, {})
            .map(response => {
                return response;
            });
        } catch (err) {
            console.log(err);
        }
    }

    public getEnterpriseId(idCustomer: string, sessionid: string): Observable<any> {
        // solo status = Creado o con este id: 8168024 lo deja pasar
        // para pasar a prod se debe quitar R9961501 del querie
        //const query = encodeURI(`select id,Razon_Social,streetAddr1,email, phone,Pagina_Web,R8184516,R8156824,R8098496,Nit,Cod__Verificacion,NombreDepartamento,NombreCiudad,Pago_Anticipo,Servicio_Posfechado,Presenciales,Recoleccion,Recepcion,1 from Clientes where id=${idCustomer} and status = 8168024 ORDER BY id WITH (NOLOCK)`);
        const query = encodeURI(`select id,name,nit,Telephone,streetAddr1,city,R345548 from client_monthe where id=${idCustomer}`);
        const url = `${getUrlEnvironment()}rest/api/selectQuery?query=` + query + "&sessionId=" + sessionid + "&output=json&maxRows=10000";
        let base;
        base = this.http.get(url);
        return base.pipe(
            map((res) => {
                if (res[0]) {
                    this.saveEnterpriseData(res);
                    this.getContactData(res[0][6], sessionid);
                }
                return res;
            })
        );
    }

    private saveEnterpriseData(entData) {
        sessionStorage.setItem("EntrepriseData", entData);
    }

    public GetEnterpriseData() {
        return sessionStorage.getItem("EntrepriseData");
    }
    
    private getContactData(CommercialId: string, sessionid: string) {
        const query = encodeURI(`select name,Telephone,Cellphone,email from seller where id=${CommercialId}`);
        let url = `${getUrlEnvironment()}rest/api/selectQuery?&query=` + query + "&sessionId=" + sessionid + "&output=json&maxRows=10000";
        this.http.get(url).subscribe(res => {
            if (res[0]) {
                this.SaveContactData(JSON.stringify(res[0]));
            }
        });
    }

    private SaveContactData(ContactData) {
        sessionStorage.setItem("ContactData", ContactData);
    }

    public GetContactData() {
        return (sessionStorage.getItem("ContactData"));
    }

    public setEmailLogin(email) {
        sessionStorage.setItem("emailLogin", email);
    }

    public getEmailLogin() {
        return sessionStorage.getItem("emailLogin");
    }

    public setLineaNegocio(linea) {
        sessionStorage.setItem("lineaNegocio", linea);
    }

    public getLineaNegocio() {
        return sessionStorage.getItem("lineaNegocio");
    }

    private SaveProfile(profile) {
        sessionStorage.setItem("Profile", profile);
    }
    public GetProfile() {
        var profile = sessionStorage.getItem("Profile");
        return profile;
    }

    public register(user: TokenPayload): Observable<any> {
        return this.request('post', 'register', user);
    }

    public login(user: TokenPayload): Observable<any> {
        return this.request('get', 'login', user);
    }

    public profile(): Observable<any> {
        return this.request('get', 'profile');
    }

    public logout(): void {
        this.SaveProfile("");
        this.saveId("");
        this.saveToken("");
    }
}



// WEBPACK FOOTER //
// /Users/clgingeniero/Documents/Proyectos/Impel/acertar/src/app/authentication/authentication.service.ts